<template>
  <div class="ll-sos">
    <img
      src="@/assets/image/img-empty/White-thankyou.png"
      alt=""
      class="send-img"
    >
    <p class="send-title">
      {{ $t('您的訊息已順利送出，本所將派員以您所填寫的聯絡方式聯繫您，或您可以改用以下聯絡方式聯繫我們，謝謝。') }}
    </p>
    <div class="list">
      <a
        class="send-title"
        href="mailto:zjchen@esgez.com"
      >
        陳小姐<i class="icon-email" />zjchen@esgez.com
      </a>
      <!-- <a
        class="send-title"
        href="tel:+886-2000-000 #123"
      >
        <i class="icon-phone" />+886-2000-000 #123
      </a> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "LlSos",
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-sos";
</style>